import React from 'react';
import { RouteComponentProps } from 'react-router';
import { ScrollToTop } from '../components/scroll_to_top/scroll_to_top';
import { OmniaVideoPageLoader } from '../components/omnia_video_page_component/omnia_video_page_loader';

const OmniaVideoPage = (props: RouteComponentProps<{ slug: string }>) => {
  const slug = props.match.params.slug;
  return (
    <ScrollToTop key={slug}>
      <OmniaVideoPageLoader slug={slug} />
    </ScrollToTop>
  );
};

export default OmniaVideoPage;
